import { useState } from 'react';
import useAuthenticatedApi from '@/src/Authentication/components/hooks/useAuthenticatedApi';
import useUserOrg from '@/src/Authentication/components/hooks/useUserOrg';

export default function useDevices() {
    const authenticatedApi = useAuthenticatedApi();
    const { orgId } = useUserOrg();
    const [devices, setDevices] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const getDevices = async () => {
        setIsLoading(true);
        const response = await authenticatedApi.get(`${orgId}/device-keys`);
        setDevices(response.data);
        setIsLoading(false);
    };

    return { getDevices, devices, isLoading };
}
